import { BaseAnalyticsService } from 'decap-cms-lib-analytics';
export class FathomAnalytics extends BaseAnalyticsService {
  constructor(config) {
    super(config);
    if (!config.apiKey) {
      throw new Error('Fathom API key is required');
    }
    if (!config.appId) {
      throw new Error('Fathom site ID is required');
    }
    this.apiEndpoint = `https://plausible.io/api/v1/stats`;
  }
  async getPageviews(period) {
    const headers = {
      Authorization: `Bearer ${this.apiKey}`
    };
    const params = new URLSearchParams({
      site_id: this.apiEndpoint,
      period,
      metrics: 'pageviews'
    });
    const response = await fetch(`${this.apiEndpoint}/timeseries?${params}`, {
      headers
    });
    const data = await response.json();
    return this.parsePageviews(data);
  }
  parsePageviews(data) {
    return data.results;
  }
}